export const DEFAULT_TITLE = 'Proxpect | Encontre tudo para a sua empresa';
export const DEFAULT_META_DESCRIPTION = 'Encontre tudo que sua empresa precisa no melhor marketplace B2B do Brasil';
